import JourneyTemplateDto from "@/models/JourneyTemplates/JourneyTemplateDto";
import ShiftDto from "@/models/Shifts/ShiftDto";
import JourneyType from "@/models/Timesheets/JourneyType";
import JourneyCalculationType from "./JourneyCalculationType";

export default class TimesheetViewModel {
    id = '';
    updatedAt: Date;
    payRate = 0;
    chargeRate = 0;
    startAtDate = '';
    startAtTime = '';
    endAtTime = '';
    break = 20;
    isPaidBreak = false;
    shiftUnitsGross = 0;
    shiftUnitsNet = 0;
    shiftPay = 0;
    shiftCharge = 0;
    shift: ShiftDto = new ShiftDto();
    isJourneyTrackingEnabled = false;
    isSplitPayAndCharge = true;
    journeyType: JourneyType = JourneyType.OwnWayThere;
    journeyCalculationTypeForPay: JourneyCalculationType = JourneyCalculationType.Manual;
    journeyCalculationTypeForCharge: JourneyCalculationType = JourneyCalculationType.Manual;
    journeyTemplateForPayId: string = null;
    journeyTemplateForPay: JourneyTemplateDto = new JourneyTemplateDto();
    journeyTemplateForChargeId: string = null;
    journeyTemplateForCharge: JourneyTemplateDto = new JourneyTemplateDto();
    passengerDeduction = 0;
    distanceOneWayManualForPay = 0;
    distanceOneWayManualForCharge = 0;
    distanceOneWayTemplateForPay = 0;
    distanceOneWayTemplateForCharge = 0;
    totalDistanceForPay = 0;
    totalDistanceForCharge = 0;
    travelTimeOneWayManualForPay = 0;
    travelTimeOneWayManualForCharge = 0;
    travelTimeOneWayTemplateForPay = 0;
    travelTimeOneWayTemplateForCharge = 0;
    totalTravelTimeForPay = 0;
    totalTravelTimeForCharge = 0;
    driverUnitExpensePayRate = 0;
    driverUnitExpenseChargeRate = 0;
    isDriverExpensePayable = false;
    isDriverExpenseChargeable = false;
    driverExpensePay = 0;
    driverExpenseCharge = 0;
    isTravelTimePayable = false;
    isTravelTimeChargeable = false;
    travelTimePay = 0;
    travelTimeCharge = 0;
    minimumPayRate = -1;
}